import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Sites from "../../constants/Sites";
import {
  findSiteNameWithoutCom,
  modalClickFunction,
  isIPadProOnSafari,
} from "../../helpers/Helper";
import NewsLetterV2 from "@components/NewsletterV2/NewsletterV2";
import Modal from "@components/Modal/Modal";
import CardSlider from "../CardSlider/CardSlider";
import AuthorCard from "../Card/AuthorCard";

import styles from "./AuthorSlider.module.css";

const AuthorSlider = (props) => {
  const { displayName = "AuthorSlider" } = props;

  const [open, setOpen] = useState();
  const [author, setAuthor] = useState("");
  const [authorId, setAuthorId] = useState();
  const [isDesktop, setIsDesktop] = useState(false);
  const [slidesPerView, setSlidesPerView] = useState(3);

  useEffect(() => {
    const updateScreenSize = () => {
      const width = window.innerWidth;
      const isIPadPro = isIPadProOnSafari();

      // iPad Pro should always use carousel, even if width >= 1024
      if (width >= 1024 && !isIPadPro) {
        setIsDesktop(true); // Desktop: no carousel
        setSlidesPerView(3); // Not used on desktop
      } else {
        setIsDesktop(false); // Tablet/Mobile/iPad Pro: use carousel
        if (width >= 768 || isIPadPro) {
          setSlidesPerView(3); // Tablet/iPad Pro: show 3 authors
        } else {
          setSlidesPerView(1); // Mobile: show 1 author
        }
      }
    };

    updateScreenSize();
    window.addEventListener("resize", updateScreenSize);
    return () => window.removeEventListener("resize", updateScreenSize);
  }, []);

  return (
    <div className={[styles[displayName], "row"].join(" ")}>
      <div className="slider-header">{props.slider_heading}</div>
      <hr />
      {isDesktop ? (
        // Desktop: Show all authors directly without carousel
        <div className="author-grid-desktop">
          {props.authors.map((author, index) => (
            <AuthorCard
              key={index}
              author={author}
              showRemoveButton={false}
              showListHeader={true}
              setOpen={setOpen}
              setAuthor={setAuthor}
              setAuthorId={setAuthorId}
            />
          ))}
        </div>
      ) : (
        // Tablet/Mobile: Use carousel
        <CardSlider
          cardType="authorcard"
          slides={props.authors}
          slidesPerView={slidesPerView}
          className="author-slider"
          autoplay={false}
          arrows={true}
          dots={slidesPerView === 1} // Only show dots when showing 1 per slide
          initialSlide={0}
          setOpen={setOpen}
          setAuthor={setAuthor}
          setAuthorId={setAuthorId}
        />
      )}
      <Modal
        isOpen={open}
        closeBtn={() => setOpen(false)}
        sizeClass={"small"}
        className={""}
        transitionName={"follow-modal"}
      >
        <NewsLetterV2
          isChild={true}
          classNames={"author-follow-newsletter"}
          isDisplayModalChecked={true}
          mainPost={false}
          subComponentType={"modal"}
          modalHeader="Get an email alert when this author’s titles go on sale!"
          buttonText="Follow"
          buttonLoadingText="Following..."
          OptIn={true}
          optInNewsletter={{
            partnerCheckbox: true,
            optInSite: findSiteNameWithoutCom(Sites.EARLYBIRDBOOKS), // Set optInSite here
            optInNewsletterCopy:
              "Yes! I also want to get the Early Bird Books newsletter featuring great deals on ebooks.",
            optInSiteSailthruLists: ["Early Bird Books"],
          }}
          primaryNewsletter={findSiteNameWithoutCom(Sites.EARLYBIRDBOOKS)}
          siteId={Sites.EARLYBIRDBOOKS}
          authorId={parseInt(authorId)}
          followButton={true}
          closeModal={() => setOpen(false)}
          modalClickFunction={() => modalClickFunction(author, "clickFollow-HomePage", "")}
        />
      </Modal>
    </div>
  );
};

AuthorSlider.propTypes = {
  displayName: PropTypes.string,
  slider_heading: PropTypes.string,
  authors: PropTypes.array,
};

export default AuthorSlider;
